import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import ArticleIcon from "@mui/icons-material/Article";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import ScreenshotMonitorIcon from "@mui/icons-material/ScreenshotMonitor";
import ImageIcon from "@mui/icons-material/Image";
import CollectionsIcon from "@mui/icons-material/Collections";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import CategoryIcon from "@mui/icons-material/Category";
import InventoryIcon from "@mui/icons-material/Inventory";
import StyleIcon from "@mui/icons-material/Style";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import SettingsIcon from "@mui/icons-material/Settings";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuIcon from "@mui/icons-material/Menu";
import AddTaskIcon from "@mui/icons-material/AddTask";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import EuroIcon from "@mui/icons-material/Euro";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export const getHomeMenus = ({ presentations, screens, templates, userId }) => {
  const homeMenu = {
    label: "sidebar.menu.home",
    type: "section",
    children: [
      {
        uri: "/",
        label: "sidebar.menuItem.home",
        type: "nav-item",
        icon: <HomeIcon sx={{ fontSize: 20 }} />,
      },
    ],
  };
  if (Number(userId) === 1) {
    homeMenu.children.push({
      uri: "/dsok/system-settings",
      label: "sidebar.menuItem.systemSettings",
      type: "nav-item",
      icon: <SettingsIcon sx={{ fontSize: 20 }} />,
    });
    homeMenu.children.push({
      label: "sidebar.menuItem.billing",
      type: "collapsible",
      icon: <ReceiptLongIcon sx={{ fontSize: 20 }} />,
      children: [
        {
          uri: "/dsok/billing/history",
          label: "sidebar.menuItem.billingHistory",
          type: "nav-item",
        },
        {
          uri: "/dsok/billing/invoices",
          label: "sidebar.menuItem.billingInvoices",
          type: "nav-item",
        },
      ],
    });
  }
  if (templates) {
    homeMenu.children.push({
      uri: "/templates",
      label: "sidebar.menuItem.templates",
      type: "nav-item",
      icon: <AutoStoriesIcon sx={{ fontSize: 20 }} />,
    });
  }
  if (presentations) {
    homeMenu.children.push({
      uri: "/presentations",
      label: "sidebar.menuItem.presentations",
      type: "nav-item",
      icon: <SlideshowIcon sx={{ fontSize: 20 }} />,
    });
  }
  if (screens) {
    homeMenu.children.push({
      uri: "/screens",
      label: "sidebar.menuItem.screens",
      type: "nav-item",
      icon: <ScreenshotMonitorIcon sx={{ fontSize: 20 }} />,
    });
  }

  return homeMenu;
};

export const getPartnerMenu = ({ partnerUser, token, lang = "sk-SK" }) => {
  let tokenUrl = "";
  if (token !== null) {
    tokenUrl = `&token=${token}`;
  }
  const partnerMenu = {
    label: "MENU",
    type: "section",
    children: [
      {
        uri: `manage/dashboard/?hl=${lang}`,
        label: "sidebar.menuItem.home",
        type: "nav-item",
        icon: <HomeIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `manage/editor/?hl=${lang}${tokenUrl}`,
        label: "sidebar.menuItem.dsokSettings",
        type: "nav-item",
        icon: <SettingsIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: `manage/orders/list/?hl=${lang}${tokenUrl}`,
        operatorAccess: true,
        label: "sidebar.menuItem.dsokOrders",
        type: "nav-item",
        icon: <CreditScoreIcon sx={{ fontSize: 20 }} />,
      },
    ],
  };
  return partnerMenu;
};

export const mediaMenus = {
  label: "sidebar.menu.media",
  type: "section",
  children: [
    {
      uri: "/media/images",
      label: "sidebar.menuItem.images",
      type: "nav-item",
      icon: <ImageIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/media/galleries",
      label: "sidebar.menuItem.galleries",
      type: "nav-item",
      icon: <CollectionsIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/media/videos",
      label: "sidebar.menuItem.videos",
      type: "nav-item",
      icon: <VideoCameraBackIcon sx={{ fontSize: 20 }} />,
    },
    // {
    //   uri: '/media/documents',
    //   label: 'sidebar.menuItem.documents',
    //   type: 'nav-item',
    //   icon: <ArticleIcon sx={{ fontSize: 20 }} />
    // }
  ],
};

export const productMenus = {
  label: "sidebar.menu.products",
  type: "collapsible",
  children: [
    {
      uri: "/products",
      label: "sidebar.menuItem.products",
      type: "nav-item",
      icon: <InventoryIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/product-categories",
      label: "sidebar.menuItem.productCategories",
      type: "nav-item",
      icon: <CategoryIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/product-attributes",
      label: "sidebar.menuItem.productAttributes",
      type: "nav-item",
      icon: <StyleIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/menus",
      label: "sidebar.menuItem.menus",
      type: "nav-item",
      icon: <RestaurantMenuIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/daily-offers",
      label: "sidebar.menuItem.dailyOffers",
      type: "nav-item",
      icon: <LocalOfferIcon sx={{ fontSize: 20 }} />,
    },
  ],
};
export const kioskMenus = {
  label: "sidebar.menu.kiosk",
  type: "collapsible",
  children: [
    {
      uri: "/kiosk/devices",
      label: "sidebar.menuItem.devices",
      type: "nav-item",
      icon: <SmartDisplayIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/kiosk/articles",
      label: "sidebar.menuItem.articles",
      type: "nav-item",
      icon: <ArticleIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/kiosk/article-categories",
      label: "sidebar.menuItem.articleCategories",
      type: "nav-item",
      icon: <CategoryIcon sx={{ fontSize: 20 }} />,
    },
    {
      uri: "/customer/dsok/bindings",
      label: "sidebar.menuItem.bindings",
      type: "nav-item",
      icon: <ConnectWithoutContactIcon sx={{ fontSize: 20 }} />,
    },
  ],
};

export const dsokMenus = (settings, dsokType = "gastrokiosk", dsokSettings) => {
  const {
    enableClients,
    enableCategories,
    enableProducts,
    enableProductAttributes,
    enableReports,
    enableSettings,
    enableDispensingOrders,
    enableCartRules,
    enableDailyMenu,
    enableBindings,
  } = settings;
  const canDisplay = dsokType === "gastrokiosk" ? true : false;
  const children = [
    {
      uri: "/customer/dsok/orders",
      operatorAccess: true,
      label: "sidebar.menuItem.dsokOrders",
      type: "nav-item",
      icon: <CreditScoreIcon sx={{ fontSize: 20 }} />,
    },
  ];
  // todo add function to check dispensing orders availability
  if (enableClients) {
    children.push({
      uri: "/customer/dsok/clients",
      operatorAccess: true,
      label: "sidebar.menuItem.clients",
      type: "nav-item",
      icon: <PeopleIcon sx={{ fontSize: 20 }} />,
    });
  }
  if (enableProducts || canDisplay) {
    children.push({
      uri: "/customer/dsok/products",
      label: "sidebar.menuItem.products",
      type: "nav-item",
      icon: <InventoryIcon sx={{ fontSize: 20 }} />,
    });
    // children.push({
    //   uri: "/customer/dsok/product-attributes",
    //   label: "sidebar.menuItem.dsokProductAttributes",
    //   type: "nav-item",
    //   icon: <StyleIcon sx={{ fontSize: 20 }} />,
    // });
  }
  if (enableCategories || canDisplay) {
    children.push({
      uri: "/customer/dsok/categories",
      label: "sidebar.menuItem.dsokCategories",
      type: "nav-item",
      icon: <CategoryIcon sx={{ fontSize: 20 }} />,
    });
    children.push({
      uri: "/customer/dsok/menu",
      label: "sidebar.menuItem.dsokMenus",
      type: "nav-item",
      icon: <MenuIcon sx={{ fontSize: 20 }} />,
    });
    if (enableBindings === true) {
      children.push({
        uri: "/customer/dsok/bindings",
        label: "sidebar.menuItem.bindings",
        type: "nav-item",
        icon: <ConnectWithoutContactIcon sx={{ fontSize: 20 }} />,
      });
    }
  }
  // Správa kioskov – dostupná pre KAŽDÉHO zákazníka, nezávislá na iných nastaveniach.
  children.push({
    uri: "/customer/dsok/kiosk-management",
    label: "sidebar.menuItem.kioskManagement",
    type: "nav-item",
    icon: <ScreenshotMonitorIcon sx={{ fontSize: 20 }} />,
  });
  // Reporty and Manažment objednávok moved to sticky (top) menu
  return {
    label: "sidebar.menu.dsok",
    type: "section",
    children: [...children],
  };
};

/**
 * Marketing section for DSOK: Špeciálne ponuky, Zľavové kupóny, Automatické zľavy.
 * Same visibility rules as when they lived under dsok; section hidden if no children.
 */
export const getMarketingSection = (settings, dsokType = "gastrokiosk") => {
  const { enableCategories, enableCartRules, enableSpecialOffers } = settings;
  const canDisplay = dsokType === "gastrokiosk" ? true : false;
  const children = [];

  if ((enableCategories || canDisplay) && enableSpecialOffers === true) {
    children.push({
      uri: "/customer/dsok/promotions",
      label: "sidebar.menuItem.dsokPromotions",
      type: "nav-item",
      icon: <LocalOfferIcon sx={{ fontSize: 20 }} />,
    });
  }
  if (enableCartRules) {
    children.push({
      uri: "/customer/dsok/shopping-cart-rules",
      label: "sidebar.menuItem.dsokCartRules",
      type: "nav-item",
      icon: <ShoppingCartIcon sx={{ fontSize: 20 }} />,
    });
    children.push({
      uri: "/customer/dsok/shopping-cart-auto-discounts",
      label: "sidebar.menuItem.automaticDiscounts",
      type: "nav-item",
      icon: <EuroIcon sx={{ fontSize: 20 }} />,
    });
  }

  if (children.length === 0) return null;
  return {
    label: "sidebar.menu.marketing",
    type: "section",
    icon: <LocalOfferIcon sx={{ fontSize: 20 }} />,
    children,
  };
};

// export const dsokMenus = {
//   label: "sidebar.menu.dsok",
//   type: "section",
//   children: [
//     {
//       uri: "/customer/dsok/clients",
//       operatorAccess: true,
//       label: "sidebar.menuItem.clients",
//       type: "nav-item",
//       icon: <PeopleIcon sx={{ fontSize: 20 }} />,
//     },
//     {
//       uri: "/customer/dsok/orders",
//       operatorAccess: true,
//       label: "sidebar.menuItem.dsokOrders",
//       type: "nav-item",
//       icon: <CreditScoreIcon sx={{ fontSize: 20 }} />,
//     },
//     {
//       uri: "/customer/dsok/categories",
//       label: "sidebar.menuItem.dsokCategories",
//       type: "nav-item",
//       icon: <CategoryIcon sx={{ fontSize: 20 }} />,
//     },
//     {
//       uri: "/customer/dsok/products",
//       label: "sidebar.menuItem.products",
//       type: "nav-item",
//       icon: <InventoryIcon sx={{ fontSize: 20 }} />,
//     },
//     {
//       uri: "/customer/dsok/product-attributes",
//       operatorAccess: true,
//       label: "sidebar.menuItem.dsokProductAttributes",
//       type: "nav-item",
//       icon: <StyleIcon sx={{ fontSize: 20 }} />,
//     },
//     {
//       uri: "/customer/dsok/reports",
//       operatorAccess: true,
//       label: "sidebar.menuItem.dsokReports",
//       type: "nav-item",
//       icon: <BarChartIcon sx={{ fontSize: 20 }} />,
//     },
//     {
//       uri: "/customer/dsok",
//       label: "sidebar.menuItem.dsokSettings",
//       type: "nav-item",
//       icon: <SettingsIcon sx={{ fontSize: 20 }} />,
//     },
//   ],
// };
export const easyPayMenus = {
  label: "sidebar.menu.easyPay",
  type: "collapsible",
  children: [
    {
      uri: "/customer/easypay/orders",
      operatorAccess: true,
      label: "sidebar.menuItem.dsokOrders",
      type: "nav-item",
      icon: <CreditScoreIcon sx={{ fontSize: 20 }} />,
    },
  ],
};

const menus = [
  {
    label: "sidebar.menu.home",
    type: "section",
    children: [
      {
        uri: "/",
        label: "sidebar.menuItem.home",
        type: "nav-item",
        icon: <HomeIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/templates",
        label: "sidebar.menuItem.templates",
        type: "nav-item",
        icon: <AutoStoriesIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/presentations",
        label: "sidebar.menuItem.presentations",
        type: "nav-item",
        icon: <SlideshowIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/screens",
        label: "sidebar.menuItem.screens",
        type: "nav-item",
        icon: <ScreenshotMonitorIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },

  {
    label: "sidebar.menu.media",
    type: "section",
    children: [
      {
        uri: "/media/images",
        label: "sidebar.menuItem.images",
        type: "nav-item",
        icon: <ImageIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/media/galleries",
        label: "sidebar.menuItem.galleries",
        type: "nav-item",
        icon: <CollectionsIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/media/videos",
        label: "sidebar.menuItem.videos",
        type: "nav-item",
        icon: <VideoCameraBackIcon sx={{ fontSize: 20 }} />,
      },
      // {
      //   uri: '/media/documents',
      //   label: 'sidebar.menuItem.documents',
      //   type: 'nav-item',
      //   icon: <ArticleIcon sx={{ fontSize: 20 }} />
      // }
    ],
  },
  {
    label: "sidebar.menu.kiosk",
    type: "section",
    children: [
      {
        uri: "/kiosk/devices",
        label: "sidebar.menuItem.devices",
        type: "nav-item",
        icon: <SmartDisplayIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/kiosk/articles",
        label: "sidebar.menuItem.articles",
        type: "nav-item",
        icon: <ArticleIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/kiosk/article-categories",
        label: "sidebar.menuItem.articleCategories",
        type: "nav-item",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok/bindings",
        label: "sidebar.menuItem.bindings",
        type: "nav-item",
        icon: <ConnectWithoutContactIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
  {
    label: "sidebar.menu.dsok",
    type: "collapsible",
    children: [
      {
        uri: "/customer/dsok/categories",
        label: "sidebar.menuItem.dsokCategories",
        type: "nav-item",
        icon: <CategoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok/promotions",
        label: "sidebar.menuItem.dsokPromotions",
        type: "nav-item",
        icon: <LocalOfferIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok/products",
        label: "sidebar.menuItem.products",
        type: "nav-item",
        icon: <InventoryIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok/orders",
        label: "sidebar.menuItem.dsokOrders",
        type: "nav-item",
        icon: <CreditScoreIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok/product-attributes",
        operatorAccess: true,
        label: "sidebar.menuItem.dsokProductAttributes",
        type: "nav-item",
        icon: <StyleIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/customer/dsok",
        label: "sidebar.menuItem.dsokSettings",
        type: "nav-item",
        icon: <SettingsIcon sx={{ fontSize: 20 }} />,
      },
    ],
  },
];

export default menus;
